export default __webpack_public_path__ + "static/media/widget-icon.1781f8fd.svg";